import {
	// APPLICATIONS_MENU_KEY,
	DASHBOARD_MENU_KEY,
	EMPLOYEES_MENU_KEY,
	JOBS_MENU_KEY,
	MATCH_CANDIDATES_MENU_KEY,
	// AI_CANDIDATES_MENU_KEY,
	SHORTLISTED_MENU_KEY,
	INVITED_MENU_KEY,
} from "./menu.keys";
import type { TFunction } from "i18next";
import { BROWSER_ROUTES } from "@constants/browser.routes";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
// import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
// import AutoModeOutlinedIcon from "@mui/icons-material/AutoModeOutlined";
import StarOutlineOutlinedIcon from "@mui/icons-material/StarOutlineOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";

export const getSidebarMenuConfig = (t: TFunction) => {
	return [
		{
			key: DASHBOARD_MENU_KEY,
			label: t("layout.sidebar.menuName.dashboard"),
			icon: <WidgetsOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.DASHBOARD,
		},
		{
			key: JOBS_MENU_KEY,
			label: t("layout.sidebar.menuName.jobs"),
			icon: <WorkOutlineOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.JOBS,
		},
		// {
		// 	key: APPLICATIONS_MENU_KEY,
		// 	label: t("layout.sidebar.menuName.applications"),
		// 	icon: <AssignmentOutlinedIcon fontSize="medium" />,
		// 	route: BROWSER_ROUTES.APPLICATIONS,
		// },
		{
			key: MATCH_CANDIDATES_MENU_KEY,
			label: t("layout.sidebar.menuName.matchCandidates"),
			icon: <GroupOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.MATCH_CANDIDATES,
		},
		// {
		// 	key: AI_CANDIDATES_MENU_KEY,
		// 	label: t("layout.sidebar.menuName.aiCandidates"),
		// 	icon: <AutoModeOutlinedIcon fontSize="medium" />,
		// 	route: BROWSER_ROUTES.AI_CANDIDATES,
		// },
		{
			key: SHORTLISTED_MENU_KEY,
			label: t("layout.sidebar.menuName.shortlisted"),
			icon: <StarOutlineOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.SHORTLISTED,
		},
		{
			key: INVITED_MENU_KEY,
			label: t("layout.sidebar.menuName.invited"),
			icon: <SendOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.INVITED,
		},
		{
			key: EMPLOYEES_MENU_KEY,
			label: t("layout.sidebar.menuName.employees"),
			icon: <PersonOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.EMPLOYEES,
		},
	];
};
